import { useGetRolesQuery } from '../models/role.api'

const useGetOrganizationRoles = () => {
  const { data } = useGetRolesQuery()

  const organizaitonRoles = (() => {
    if (data) {
      return data.records.map((record) => record.name)
    }
    return []
  })()

  return {
    data: organizaitonRoles,
  }
}

export default useGetOrganizationRoles
